import { styled } from '@withjoy/joykit';
import { SuccessGuestButton } from '@apps/registry/guest/components/SuccessGuestButton';

export const StyledSuccessGuestButton = styled(SuccessGuestButton)`
  background: #176f69;
`;
